__turbopack_context__.v({
  "body": "ProfileSkillsInput-module-scss-module__lMJy1W__body",
  "header": "ProfileSkillsInput-module-scss-module__lMJy1W__header",
  "hint": "ProfileSkillsInput-module-scss-module__lMJy1W__hint",
  "label": "ProfileSkillsInput-module-scss-module__lMJy1W__label",
  "root": "ProfileSkillsInput-module-scss-module__lMJy1W__root",
  "row": "ProfileSkillsInput-module-scss-module__lMJy1W__row",
});
